import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdunitApiService from '../../ApiServices/AnalyticsApiService/AdunitApiService';
import { useAuth } from '../Auth/AuthContext';
import AddAdunitForm from './AddAdunitForm';
import DataTable from 'react-data-table-component';

const AdunitTable = () => {
    const [adunits, setAdunits] = useState([]);
    const [filteredAdunits, setFilteredAdunits] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const Auth = useAuth();
    const user = Auth.authState.user;
    const isAdmin = Auth.authState.roles === "Admin";

    useEffect(() => {
        if (user && user.id) {
            fetchAdunits();
        }
    }, [user]);

    const fetchAdunits = async () => {
        setLoading(true);
        try {
            const response = await AdunitApiService.getAll();
            const data = response.data || [];
            setAdunits(data);
            setFilteredAdunits(data);
        } catch (error) {
            toast.error('Failed to fetch adunits.');
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = adunits.filter(adunit =>
            adunit.name.toLowerCase().includes(value)
        );
        setFilteredAdunits(filtered);
    };

    const openModal = (adunit = null) => {
        setCurrentItem(adunit);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setCurrentItem(null);
        fetchAdunits();
    };

    const handleAdunitSubmit = async (adunitData) => {
        try {
            // await AdunitApiService.create(adunitData);
            // toast.success('AdUnit added successfully!');
            closeModal();
        } catch (error) {
            toast.error('Failed to process request.');
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this AdUnit?')) {
            try {
                await AdunitApiService.delete(id);
                toast.success('AdUnit deleted successfully!');
                fetchAdunits();
            } catch (error) {
                toast.error('Failed to delete AdUnit.');
            }
        }
    };

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Is Active',
            selector: row => (row.isActive ? 'Yes' : 'No'),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: row =>
                isAdmin && (
                    <div className="flex space-x-2">
                        {/* <button
                            onClick={() => openModal(row)}
                            className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded-md text-sm"
                        >
                            Edit
                        </button> */}
                        <button
                            onClick={() => handleDelete(row.id)}
                            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-md text-sm"
                        >
                            Delete
                        </button>
                    </div>
                ),
        },
    ];

    return (
        <div className="p-6">
            <ToastContainer />
            <div className="bg-white shadow-xl rounded-xl p-6 border border-gray-100">
                <div className="flex justify-between items-center mb-4">
                    <input
                        type="text"
                        placeholder="🔍 Search by name..."
                        value={searchTerm}
                        onChange={handleSearch}
                        className="border px-4 py-2 rounded-lg shadow-sm w-full max-w-xs"
                    />
                    {isAdmin && (
                        <button
                            onClick={() => openModal()}
                            className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-6 py-2 rounded-lg ml-4 shadow hover:from-indigo-600 hover:to-purple-700 transition"
                        >
                            ➕ Add AdUnit
                        </button>
                    )}
                </div>

                <DataTable
                    columns={columns}
                    data={filteredAdunits}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    customStyles={{
                        headCells: {
                            style: {
                                backgroundColor: '#111827',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '14px',
                            },
                        },
                    }}
                />
            </div>

            {/* Modal for Add/Edit */}
            {modalIsOpen && (
                <AddAdunitForm
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    onSubmit={handleAdunitSubmit}
                    adunit={currentItem}
                />
            )}
        </div>
    );
};

export default AdunitTable;
